import { CanDeactivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { ConfirmDialogComponent } from '../../ui/dialogs/confirm-dialog/confirm-dialog.component';

export interface HasUnsavedChanges {
  hasUnsavedChanges(): boolean
}

export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = async (component) => {
  if (component.hasUnsavedChanges?.()) {
    const dialog = inject(MatDialog)
    const dialogRef = dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Ungespeicherte Änderungen',
        message: 'Du hast ungespeicherte Änderungen. Möchtest du die Seite wirklich verlassen?',
        confirmText: 'Verlassen'
      }
    })
    const result = await firstValueFrom(dialogRef.afterClosed())
    return !!result
  }
  return true
}
